// Get DOM elements
const sendAsGiftCheckbox = document.getElementById('sendAsGift');
const giftDetails = document.querySelector('.gf-gift-details');
const recipientEmailInput = document.getElementById('recipientEmail');
const recipientNameInput = document.getElementById('recipientName');
const messageInput = document.getElementById('message');
const sendDateInput = document.getElementById('sendDate');
const add_to_cart_button_gift_card = document.getElementById('product-add-to-cart');
const emailError = document.getElementById('emailError');
const nameError = document.getElementById('nameError');
const messageError = document.getElementById('messageError');
const dateError = document.getElementById('dateError');

// Consolidated validation function
function validateAll() {
    const isEmailValid = isValidEmail(recipientEmailInput.value);
    const isNameValid = recipientNameInput.value.trim() !== '';
    const isDateValid = validateDate(true); // Pass a parameter to indicate check only, no UI update
    add_to_cart_button_gift_card.disabled = !(isEmailValid && isNameValid && isDateValid);
}

// Email validation logic
function isValidEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
}

// Validate email and update UI
function validateEmailAndUpdateUI() {
    const email = recipientEmailInput.value;
    emailError.textContent = isValidEmail(email) ? '' : 'Please enter a valid email address.';
    validateAll();
}

// Name validation logic
function validateName() {
    const name = recipientNameInput.value.trim();
    nameError.textContent = name ? '' : 'Please enter a valid name.';
}

// Date validation logic
function validateDate(checkOnly = false) {
    const currentDate = Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate());
    const inputDateValue = sendDateInput.value;
    const selectedDate = inputDateValue ? Date.UTC(new Date(inputDateValue).getUTCFullYear(), new Date(inputDateValue).getUTCMonth(), new Date(inputDateValue).getUTCDate()) : NaN;
    let message = '';

    if (inputDateValue && !isNaN(selectedDate)) {
        if (selectedDate < currentDate) {
            message = 'Please choose today or a date after.';
        } else {
            message = ''; // Date is valid
        }
    } else {
        message = 'Invalid date. Please enter a valid date.';
    }

    if (!checkOnly) {
        dateError.textContent = message;
        dateError.style.display = message ? 'block' : 'none';
    }

    return !message;
}



// Function to show gift details
function showGiftDetails() {
    giftDetails.classList.add('visible');
    validateGiftForm();
}

// Function to hide gift details
function hideGiftDetails() {
    giftDetails.classList.remove('visible');
    clearGiftForm();
    add_to_cart_button_gift_card.disabled = false;
}

// Function to validate the entire gift form
function validateGiftForm() {
    validateEmailAndUpdateUI();
    validateName();
    validateDate();
    validateAll();
}

// Function to clear error messages and reset input fields
function clearGiftForm() {
    clearErrorMessages();
    resetInputFields();
}

// Function to clear all error messages
function clearErrorMessages() {
    emailError.textContent = '';
    nameError.textContent = '';
    dateError.textContent = '';
    messageError.textContent = '';
    dateError.classList.remove('visible');
}

// Function to reset all input fields
function resetInputFields() {
    recipientEmailInput.value = '';
    recipientNameInput.value = '';
    messageInput.value = '';
    sendDateInput.value = '';
}

// Event listener for the 'Send as Gift' checkbox
sendAsGiftCheckbox.addEventListener('change', function () {
    if (sendAsGiftCheckbox.checked) {
        showGiftDetails();
    } else {
        hideGiftDetails();
    }
});


recipientEmailInput.addEventListener('input', validateEmailAndUpdateUI);
recipientNameInput.addEventListener('input', validateName);
recipientNameInput.addEventListener('blur', validateAll);
messageInput.addEventListener('blur', validateAll);
sendDateInput.addEventListener('change', function () {
    validateDate();
    validateAll();
});
sendDateInput.addEventListener('blur', function () {
    validateDate();
    validateAll();
});
